<template>
  <main id="products-list" class="site-main">
    <div class="grid-container">
      <div class="list-actions text-right">
        <span class="icon-action" @click="exportProducts">
          <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
        </span>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search products" @sort="sort" :value="searchValue"
                   @search="search" :dateFilter="true" @dateFilter="dateFilter"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                        @paginate="paginate"></pagination>

            <tableList classes="no-hover" :header="tableHeader" :data="tableData"
                       :loading="loading" @sort="orderBy"></tableList>

            <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                        @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import moment from 'moment'

export default {
  name: 'productsList',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/products/?expand=variants',
      sort: '-created_at',
      tableHeader: {
        data: [
          {
            label: 'Product',
            class: 'full',
            sort: 'title'
          },
          {
            label: 'Price',
            class: 'medium'
          },
          {
            label: 'Cost',
            class: 'medium'
          },
          {
            label: 'Type',
            class: 'large',
            sort: 'product_type'
          },
          {
            label: 'Inventory',
            class: 'xlarge',
            sort: 'inventory'
          },
          {
            label: 'Sold',
            class: 'small',
            sort: 'sold'
          },
          {
            label: 'Created',
            class: 'large',
            sort: 'created_at'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportProducts () {
      let exportAction = '/products/'

      if (this.$store.state.shop.myshopify_domain === 'the-harmonic-au.myshopify.com') {
        exportAction = '/products/variants/'
      }

      this.request('get', exportAction, {
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    dateFilter (startDate, endDate) {
      this.params = {}
      if (startDate.length > 0) {
        this.params['start_date'] = startDate
      } else {
        delete this.params['start_date']
      }

      if (endDate.length > 0) {
        this.params['end_date'] = endDate
      } else {
        delete this.params['end_date']
      }

      if (this.params['start_date'] || this.params['end_date']) {
        this.action = '/products/sold/?expand=variants'
      } else {
        this.action = '/products/?expand=variants'
      }

      this.getData()
    },
    go: function (id) {
      this.$router.push('/products/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(this.data[i].image)) {
          let ext = this.data[i].image.split('.').pop()

          this.data[i].image = this.data[i].image.replace('.' + ext, '_100x100.' + ext)

          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.data[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        primary += '</div></div><div class="cell auto">' + this.data[i].title + '</div></div>'

        let variantCount = 0
        let inventoryCount = 0
        let inventoryNotTracked = 0

        for (let j = 0; j < this.data[i]['variants'].length; j++) {
          variantCount++
          inventoryCount += this.data[i]['variants'][j]['inventory_quantity']
          // sold += this.data[i]['variants'][j]['sold']

          if (!this.data[i]['variants'][j]['inventory_management']) {
            inventoryNotTracked++
          }
        }

        let inventory = inventoryCount + ' in stock'

        if (variantCount > 1) {
          inventory = inventory + ' for ' + variantCount + ' variants'
        }
        //
        // if (inventoryNotTracked === variantCount) {
        //   inventory = '<span class="text-medium-gray-color">inventory not tracked</span>'
        // }

        let priceCol = {}

        let lowestPrice = 9999999999

        if (this.data[i].variants) {
          for (let j = 0; j < this.data[i].variants.length; j++) {
            if (this.data[i].variants[j].price < lowestPrice) {
              lowestPrice = this.data[i].variants[j].price
            }
          }

          let price = this.formatMoney(lowestPrice)

          if (this.data[i].variants.length > 1) {
            price = 'starting at %s' % price
          }

          priceCol = {
            value: price,
            class: 'medium'
          }
        }

        let costCol = {}

        if (this.$store.state.shop.myshopify_domain === 'the-thrifting-den.myshopify.com') {
          let costPerItem = 0.0

          if (this.data[i].variants[0].cost_per_item) {
            costPerItem = this.data[i].variants[0].cost_per_item
          }
          costCol = {
            value: this.formatMoney(costPerItem),
            class: 'medium'
          }
        }

        this.tableData.push({
          // post: this.data[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },
            priceCol,
            costCol,
            {
              value: this.data[i].product_type,
              class: 'large'
            },
            {
              value: inventory,
              class: 'xlarge'
            },
            {
              value: this.data[i].deleted,
              class: 'small'
            },
            {
              value: moment(this.data[i].created_at).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            }
          ]
        })
      }
    }
  },
  created () {
    if (this.$store.state.vendor) {
      this.action = this.action + '&vendor=' + this.$store.state.vendor.id
    }

    if (this.$store.state.shop.myshopify_domain !== 'the-thrifting-den.myshopify.com') {
      this.tableHeader.data[2] = {}
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/products/list.vue